module.exports = __webpack_public_path__ + "img/vu.8102b177.jpg";